import React from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function DriverSelfRatingsSessionMenu() {
  return (
    <Grid id="self-rating-selection-grid" fluid>
      <Row id="role-selection-row">
        <Col xs={10} xsOffset={1} className="role-selection-col">
          <Col className="role-title" xs={12}>Select to Rate</Col>

          <Col xs={12} md={6} className="no-padding-left">
            <Link to="/rating/self/practice">
              <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
                Practice
              </Button>
            </Link>
          </Col>
          <Col xs={12} md={6} className="no-padding-right">
            <Link to="/rating/self/qualifying">
              <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
                Qualifying
              </Button>
            </Link>
          </Col>
          <Col xs={12} md={6} className="no-padding-left">
            <Link to="/rating/self/race">
              <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
                Race
              </Button>
            </Link>
          </Col>
          <Col xs={12} md={6} className="no-padding-right">
            <Link to="/rating/self/reflection">
              <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
                Reflection
              </Button>
            </Link>
          </Col>
        </Col>
      </Row>
    </Grid>
  );
}
